import React from "react";
import { Link } from "react-router-dom";
import Slideone from "../../assets/images/main-slider/slider-1.jpg";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import bookicon1 from "../../assets/images/resource/book-icon-1.png";
import usePagePhotos from "../../hooks/usePagePhotos";

function Banner() {
  const { getPhoto } = usePagePhotos('home');

  // Get slide image from CMS or use hardcoded fallback
  const slide1Photo = getPhoto('banner_slide_1');
  const slide1Url = (slide1Photo && slide1Photo.url) ? slide1Photo.url : Slideone;

  return (
    <section className="banner-section">
      <div className="banner-container">
        <div className="banner-slider">
          <Swiper
            modules={[Navigation]}
            loop={true}
            spaceBetween={0}
            slidesPerView={1}
            navigation={{
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            }}
          >
            <SwiperSlide>
              <div className="slide-item">
                <div
                  className="image-layer"
                  style={{ backgroundImage: `url(${slide1Url})` }}
                ></div>
                <div className="auto-container">
                  <div className="content-box">
                    <div className="content">
                      <div className="clearfix">
                        <div className="inner">
                          <div className="subtitle">
                            <span>delightful experience</span>
                          </div>
                          <div className="pattern-image">
                            <img
                              src={
                                require("../../assets/images/icons/separator.svg")
                                  .default
                              }
                              alt="mySvgImage"
                            />
                          </div>
                          <h1>
                            <span>
                              Elegant Dining, <br />
                              Extraordinary Memories
                            </span>
                          </h1>
                          <div className="text">
                            Immerse Yourself in Unparalleled Luxury!
                          </div>
                          <div
                            className="links-box wow fadeInUp"
                            data-wow-delay="0ms"
                            data-wow-duration="1500ms"
                          >
                            <div className="link">
                              <Link
                                to="/menu"
                                className="theme-btn btn-style-two clearfix"
                              >
                                <span className="btn-wrap">
                                  <span className="text-one">
                                    view our menu
                                  </span>
                                  <span className="text-two">
                                    view our menu
                                  </span>
                                </span>
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          </Swiper>

          <div className="swiper-button-prev">
            <span className="fal fa-angle-left"></span>
          </div>
          <div className="swiper-button-next">
            <span className="fal fa-angle-right"></span>
          </div>
        </div>
      </div>

      <div className="book-btn">
        <Link to="/reservation" className="theme-btn">
          <span className="icon">
            <img src={bookicon1} alt="" title="" />
          </span>
          <span className="txt">book a table</span>
        </Link>
      </div>
    </section>
  );
}

export default Banner;
